import MathEx from "../../LTGame/LTUtils/MathEx";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import UI_NativeInterstitalMediator from "../../LTGame/UIExt/DefaultUI/UI_NativeInterstitalMediator";
export class LTG_Com_NativeData {
    Send() {
        let showNativeInterstitial = () => __awaiter(this, void 0, void 0, function* () {
            let ad = yield LTPlatform.instance.getNativeAd(MathEx.RandomFromArray(LTPlatform.instance.platformData.nativeinpageIds));
            if (ad) {
                this.native = ad;
                UI_NativeInterstitalMediator.instance.Show(this);
                return 0;
            }
        });
        showNativeInterstitial();
        return 0;
    }
}
